import { Roles, Rules } from "./enums/Roles";
const sidebarItems = [
  {
    title: "dashboard",
    link: "dashboard",
    name: "/dashboard",
    type: "collapse",
    icon: "dashboard",
    roles: [
      Roles.AGMSAdmin,
      Roles.PartnerAdmin,
      Roles.GroupAdmin,
      Roles.GroupAudit,
      Roles.SiteAdmin,
      Roles.SiteAudit,
      Roles.CompanyAdmin,
    ],
    children: [
      {
        title: "companyOverview",
        link: "company-overview",
        roles: [
          Roles.AGMSAdmin,
          Roles.PartnerAdmin,
          Roles.GroupAdmin,
          Roles.GroupAudit,
          Roles.SiteAdmin,
          Roles.SiteAudit,
          Roles.CompanyAdmin,
        ],
      },
      {
        title: "mainDashboard",
        link: "custom-dashboard",
        roles: [
          // Roles.PartnerAdmin,
          // Roles.GroupAdmin,
          // Roles.GroupAudit,
          // Roles.SiteAdmin,
          // Roles.SiteAudit,
          // Roles.CompanyAdmin,
        ],
      },
    ],
  },
  {
    title: "administration",
    link: "administration",
    name: "/administration",
    type: "collapse",
    icon: "administration",
    roles: [
      Roles.AGMSAdmin,
      Roles.PartnerAdmin,
      Roles.CompanyAdmin,
      Roles.SiteAdmin,
      Roles.GroupAdmin,
      Roles.GroupAudit,
      Roles.SiteAudit,
    ],
    children: [
      {
        title: "companiesDashboard",
        link: "manage-company",
        roles: [Roles.AGMSAdmin,Roles.PartnerAdmin],
      },
      {
        title: "manageCompany",
        link: "company-list",
        roles: [Roles.PartnerAdmin],
      },
      {
        title: "managePartners",
        link: "manage-partners",
        roles: [Roles.AGMSAdmin],
      },
      {
        title: "manageUsers",
        link: "users",
        roles: [Roles.AGMSAdmin, Roles.PartnerAdmin],
      },
      {
        title: "manageLicence",
        link: "manage-license",
        roles: [Roles.PartnerAdmin],
      },
      {
        title: "installPackage",
        link: "install-package",
        roles: [Roles.AGMSAdmin],
      },
      {
        title: "addPublisher",
        link: "add-publisher",
        roles: [Roles.PartnerAdmin],
      },
      {
        title: "auditViewer",
        link: "audit-viewer",
        roles: [Roles.AGMSAdmin, Roles.PartnerAdmin],
      },
      {
        title: "globaRolePolicies",
        link: "global-role-policies",
        roles: [Roles.PartnerAdmin],
      },

      // Company Admin
      {
        title: "manageDashboard",
        link: "manage-dashboard",
        roles: [Roles.CompanyAdmin],
      },

      {
        title: "companyManagement",
        link: "company-overview",
        roles: [Roles.CompanyAdmin],
      },
      {
        title: "agentSettings",
        link: "agent-settings",
        roles: [Roles.CompanyAdmin],
      },
      {
        title: "rolePolicyList",
        link: "role-policy-list",
        roles: [Roles.CompanyAdmin],
      },

      // Group
      {
        title: "groupDashboard",
        link: "group-dashboard",
        roles: [Roles.GroupAdmin],
      },

      // Site
      {
        title: "siteOverview",
        link: "site-overview",
        roles: [Roles.SiteAdmin],
      },
      {
        title: "groupList",
        link: "group-list",
        roles: [Roles.SiteAdmin],
      },

      // {
      //   title: "pdpsLrps",
      //   link: "pdpsandlrps",
      //   roles: [Roles.CompanyAdmin, Roles.SiteAdmin, Roles.GroupAdmin],
      // },
      {
        title: "agentTask",
        link: "agent-task",
        roles: [Roles.CompanyAdmin, Roles.SiteAdmin, Roles.GroupAdmin],
      },
      // {
      //   title: "networks",
      //   link: "networks",
      //   roles: [Roles.CompanyAdmin, Roles.SiteAdmin, Roles.GroupAdmin],
      // },

      ///// Start of policy analysis
      {
        title: "policyAnalysis",
        link: "policy-overview",
        subParent: "policy-overview",
        roles: [
          Roles.CompanyAdmin,
          Roles.GroupAdmin,
          Roles.SiteAdmin,
          Roles.AGMSAdmin,
          Roles.PartnerAdmin,
        ],
        rules: [Rules.AGMSGroupSelect],
      },
      {
        title: "policyOverview",
        link: "policy-overview",
        subParent: "policy-overview",
        class: "pl-3",
        roles: [
          Roles.CompanyAdmin,
          Roles.GroupAdmin,
          Roles.SiteAdmin,
          Roles.AGMSAdmin,
          Roles.PartnerAdmin,
        ],
        rules: [Rules.AGMSGroupSelect],
      },
      {
        title: "policyReview",
        link: "policy-review",
        subParent: "policy-overview",
        class: "pl-3",
        roles: [
          Roles.CompanyAdmin,
          Roles.GroupAdmin,
          Roles.SiteAdmin,
          Roles.AGMSAdmin,
          Roles.PartnerAdmin,
        ],
        rules: [Rules.AGMSGroupSelect],
      },
      {
        title: "policyTuning",
        link: "policy-tuning",
        subParent: "policy-overview",
        class: "pl-3",
        roles: [
          Roles.CompanyAdmin,
          Roles.GroupAdmin,
          Roles.SiteAdmin,
          Roles.AGMSAdmin,
          Roles.PartnerAdmin,
        ],
        rules: [Rules.AGMSGroupSelect],
      },
      {
        title: "policyCompare",
        link: "policy-compare",
        subParent: "policy-overview",
        class: "pl-3",
        roles: [
          Roles.CompanyAdmin,
          Roles.GroupAdmin,
          Roles.SiteAdmin,
          Roles.AGMSAdmin,
          Roles.PartnerAdmin,
        ],
        rules: [Rules.AGMSGroupSelect],
      },

      ///// Start of policy
      {
        title: "policyDefinition",
        // link: "default-enclave",
        disabled: true,
        class: "no-dim",
        roles: [
          Roles.CompanyAdmin,
          Roles.GroupAdmin,
          Roles.SiteAdmin,
          Roles.AGMSAdmin,
          Roles.PartnerAdmin,
        ],
        rules: [Rules.AGMSGroupSelect, Rules.AGMSTemplateSelect],
      },
      {
        title: "appGroupManagement",
        link: "app-group-management",
        class: "pl-3",
        roles: [
          Roles.AGMSAdmin,
          Roles.PartnerAdmin,
          Roles.CompanyAdmin,
          Roles.GroupAdmin,
          Roles.SiteAdmin,
        ],
        rules: [Rules.AGMSGroupSelect],
      },
      {
	      title: "globalPolicy",
	      link: "global-policy-management",
        class: "pl-3",
	      roles: [
          Roles.AGMSAdmin,
          Roles.PartnerAdmin,
          Roles.CompanyAdmin,
          Roles.GroupAdmin,
          Roles.SiteAdmin,
        ],
        rules: [Rules.AGMSGroupSelect],
      },
      {
        title: "App Group Management",
        link: "app-group-management-role",
        class: "pl-3",
        roles: [
          Roles.CompanyAdmin,
        ],
        rules: [Rules.AGMSTemplateSelect],
      },
      {
        title: "Global Policy",
        link: "global-policy-management-role",
        class: "pl-3",
        roles: [
          Roles.CompanyAdmin,
        ],
        rules: [Rules.AGMSTemplateSelect],
      },
      {
        title: "trustedPublishers",
        link: "trusted-publishers",
        class: "pl-3",
        roles: [
          Roles.CompanyAdmin,
          Roles.GroupAdmin,
          Roles.SiteAdmin,
          Roles.AGMSAdmin,
          Roles.PartnerAdmin,
        ],
        rules: [Rules.AGMSGroupSelect, Rules.AGMSTemplateSelect],
      },
      // {
      //   title: "netlockPolicy",
      //   link: "netlock-policy",
      //   class: "pl-3",
      //   roles: [
      //     Roles.AGMSAdmin,
      //     Roles.PartnerAdmin,
      //     // Roles.CompanyAdmin,
      //     Roles.SiteAdmin,
      //     // Roles.GroupAdmin,
      //     // Roles.GroupAudit,
      //     // Roles.SiteAudit,
      //   ],
      //   rules: [Rules.AGMSGroupSelect, Rules.AGMSTemplateSelect],
      // },
      {
        title: "removableMedia",
        link: "removable-media",
        class: "pl-3",
        roles: [
          Roles.CompanyAdmin,
          Roles.GroupAdmin,
          Roles.SiteAdmin,
          Roles.AGMSAdmin,
          Roles.PartnerAdmin,
        ],
        rules: [Rules.AGMSGroupSelect],
      },
      {
        title: "removableMedia",
        link: "removable-media-role",
        class: "pl-3",
        roles: [
          Roles.CompanyAdmin,
        ],
        rules: [Rules.AGMSTemplateSelect],
      },
      // {
      //   title: "customScripts",
      //   link: "custom-scripts",
      //   class: "pl-3",
      //   roles: [
      //     Roles.CompanyAdmin,
      //     Roles.GroupAdmin,
      //     Roles.SiteAdmin,
      //     Roles.AGMSAdmin, Roles.PartnerAdmin,
      //   ],
      //   rules: [Rules.AGMSGroupSelect],
      // },
      {
        title: "ignoreEvents",
        link: "ignore-events",
        class: "pl-3",
        roles: [
          Roles.AGMSAdmin,
          Roles.PartnerAdmin,
          Roles.CompanyAdmin,
          Roles.GroupAdmin,
          Roles.SiteAdmin,
        ],
        rules: [Rules.AGMSGroupSelect],
      },
      {
        title: "severityEvents",
        link: "severity-events",
        class: "pl-3",
        roles: [
          Roles.AGMSAdmin,
          Roles.PartnerAdmin,
          Roles.CompanyAdmin,
          Roles.GroupAdmin,
          Roles.SiteAdmin,
        ],
        rules: [Rules.AGMSGroupSelect],
      },
      {
        title: "ignoreEvents",
        link: "ignore-events-role",
        class: "pl-3",
        roles: [
          Roles.CompanyAdmin,
        ],
        rules: [Rules.AGMSTemplateSelect],
      },
      {
        title: "severityEvents",
        link: "severity-events-role",
        class: "pl-3",
        roles: [
          Roles.CompanyAdmin,
        ],
        rules: [Rules.AGMSTemplateSelect],
      },
      {
        title: "summaryEvents",
        link: "summary-events",
        class: "pl-3",
        roles: [
          Roles.AGMSAdmin,
          Roles.PartnerAdmin,
          Roles.CompanyAdmin,
          Roles.GroupAdmin,
          Roles.SiteAdmin,
        ],
        rules: [Rules.AGMSGroupSelect],
      },
      {
        title: "summaryEvents",
        link: "summary-events-role",
        class: "pl-3",
        roles: [
          Roles.CompanyAdmin,
        ],
        rules: [Rules.AGMSTemplateSelect],
      },
      {
        title: "File Types Policy",
        link: "file-types-policy-role",
        class: "pl-3",
        roles: [
          Roles.CompanyAdmin,
        ],
        rules: [Rules.AGMSTemplateSelect],
      },
      {
	      title: "fileTypesPolicy",
	      link: "file-types-policy",
        class: "pl-3",
	      roles: [
          Roles.AGMSAdmin,
          Roles.PartnerAdmin,
          Roles.CompanyAdmin,
          Roles.GroupAdmin,
          Roles.SiteAdmin,
        ],
        rules: [Rules.AGMSGroupSelect],
      },
      ///// End of policy
      // {
      //   title: "scripts",
      //   link: "scripts",
      //   roles: [Roles.CompanyAdmin],
      // },
      {
        title: "manageUsers",
        link: "users",
        roles: [Roles.CompanyAdmin],
      },
      {
        title: "auditViewer",
        link: "company-audit-viewer",
        roles: [Roles.CompanyAdmin],
      },
      {
        title: "userActivity",
        link: "user-activity",
        roles: [Roles.PartnerAdmin, Roles.CompanyAdmin],
      },
      {
        title: "publishers",
        link: "publishers",
        roles: [Roles.CompanyAdmin],
      },
      {
        title: "policyAnalysis",
        link: "policy-overview",
        subParent: "policy-overview",
        roles: [Roles.CompanyAdmin],
      },
      {
        title: "policyOverview",
        link: "policy-overview",
        subParent: "policy-overview",
        class: "pl-3",
        roles: [Roles.CompanyAdmin],
      },
      {
        title: "policyReview",
        link: "policy-review",
        subParent: "policy-overview",
        class: "pl-3",
        disabled: true,
        roles: [Roles.CompanyAdmin],
      },
      {
        title: "policyTuning",
        link: "policy-tuning",
        subParent: "policy-overview",
        class: "pl-3",
        disabled: true,
        roles: [Roles.CompanyAdmin],
      },
      {
        title: "policyCompare",
        link: "policy-compare",
        subParent: "policy-overview",
        class: "pl-3",
        disabled: true,
        roles: [Roles.CompanyAdmin],
      },

      // {
      //   title: "auditViewer",
      //   link: "audit-viewer",
      //   roles: [
      //     Roles.AGMSAdmin, Roles.PartnerAdmin,
      //     Roles.CompanyAdmin,
      //     Roles.SiteAdmin,
      //     Roles.GroupAdmin,
      //   ],
      // },
    ],
    siteChildren: [
      {
        title: "groupList",
        link: "group-list",
        roles: [
          Roles.AGMSAdmin,
          Roles.PartnerAdmin,
          Roles.CompanyAdmin,
          Roles.CompanyAdmin,
        ],
      },
      // Overview
      {
        title: "overview",
        link: "company-overview",
        roles: [
          Roles.AGMSAdmin,
          Roles.PartnerAdmin,
          Roles.CompanyAdmin,
          Roles.CompanyAdmin,
        ],
      },
      // Group List

      // PDPs /LRPs List
      // {
      //   title: "pdpsLrps",
      //   link: "pdpsandlrps",
      //   roles: [
      //     Roles.AGMSAdmin,
      //     Roles.PartnerAdmin,
      //     Roles.CompanyAdmin,
      //   ],
      // },
      // Networks
      // {
      //   title: "networks",
      //   link: "networks",
      //   roles: [Roles.AGMSAdmin, Roles.PartnerAdmin, Roles.CompanyAdmin, Roles.CompanyAdmin],
      // },
      // Policy analysis
      {
        title: "policyAnalysis",
        link: "policy-overview",
        subParent: "policy-overview",
        roles: [Roles.SiteAdmin],
      },
      {
        title: "policyOverview",
        link: "policy-overview",
        subParent: "policy-overview",
        class: "pl-3",
        roles: [Roles.SiteAdmin],
      },
      {
        title: "policyReview",
        link: "policy-review",
        subParent: "policy-overview",
        class: "pl-3",
        disabled: true,
        roles: [Roles.SiteAdmin],
      },
      {
        title: "policyTuning",
        link: "policy-tuning",
        subParent: "policy-overview",
        class: "pl-3",
        disabled: true,
        roles: [Roles.SiteAdmin],
      },
      {
        title: "policyCompare",
        link: "policy-compare",
        subParent: "policy-overview",
        class: "pl-3",
        disabled: true,
        roles: [Roles.SiteAdmin],
      },
    ],
    groupChildren: [
      {
        title: "groupDashboard",
        link: "group-dashboard",
        roles: [
          Roles.AGMSAdmin,
          Roles.PartnerAdmin,
          Roles.CompanyAdmin,
          Roles.CompanyAdmin,
        ],
      },
      // Overview
      {
        title: "overview",
        link: "company-overview",
        roles: [
          Roles.AGMSAdmin,
          Roles.PartnerAdmin,
          Roles.CompanyAdmin,
          Roles.CompanyAdmin,
        ],
      },
      // Group List
      {
        title: "groupList",
        link: "group-list",
        roles: [
          Roles.AGMSAdmin,
          Roles.PartnerAdmin,
          Roles.CompanyAdmin,
          Roles.CompanyAdmin,
        ],
      },
      // Group Dashboard

      // PDPs /LRPs List
      // {
      //   title: "pdpsLrps",
      //   link: "pdpsandlrps",
      //   roles: [
      //     Roles.AGMSAdmin,
      //     Roles.PartnerAdmin,
      //     Roles.CompanyAdmin,
      //   ],
      // },
      // Networks
      // {
      //   title: "networks",
      //   link: "networks",
      //   roles: [Roles.AGMSAdmin, Roles.PartnerAdmin, Roles.CompanyAdmin, Roles.CompanyAdmin],
      // },
    ],
  },
  {
    title: "alertConsole",
    link: "/alert-console/all",
    name: "alertConsole",
    icon: "alert",
    roles: [
      Roles.AGMSAdmin,
      // Roles.PartnerAdmin,
      Roles.GroupAdmin,
      Roles.GroupAudit,
      Roles.SiteAdmin,
      Roles.SiteAudit,
      Roles.CompanyAdmin,
    ],
  },
  {
    title: "hashInspection",
    link: "/hash-inspection/malicious",
    name: "threats",
    icon: "hash-inspection",
    roles: [
      Roles.GroupAdmin,
      Roles.GroupAudit,
      Roles.SiteAdmin,
      Roles.SiteAudit,
      Roles.CompanyAdmin,
    ],
  },
  {
    title: "eventInspection",
    link: "/event-inspection/all-events",
    name: "eventInspection",
    icon: "event-inspection",
    roles: [
      Roles.GroupAdmin,
      Roles.GroupAudit,
      Roles.SiteAdmin,
      Roles.SiteAudit,
      Roles.CompanyAdmin,
    ],
  },
  // {
  //   title: "savedFilters",
  //   link: "/saved-filters/eventPageFilter",
  //   icon: "filters",
  //   roles: [
  //     Roles.AGMSAdmin, Roles.PartnerAdmin,
  //     Roles.GroupAdmin,
  //     Roles.GroupAudit,
  //     Roles.SiteAdmin,
  //     Roles.SiteAudit,
  //     Roles.CompanyAdmin,
  //   ],
  // },
  {
    title: "assets",
    link: "/endpoints/computers/all",
    name: "assets",
    icon: "assets",
    roles: [
      Roles.PartnerAdmin,
      Roles.GroupAdmin,
      Roles.GroupAudit,
      Roles.SiteAdmin,
      Roles.SiteAudit,
      Roles.CompanyAdmin,
    ],
  },
  // {
  //   title: "CTI",
  //   link: "/cti",
  //   name: "Cti",
  //   icon: "cyber",
  //   roles: [
  //     Roles.GroupAdmin,
  //     Roles.GroupAudit,
  //     Roles.SiteAdmin,
  //     Roles.SiteAudit,
  //     Roles.CompanyAdmin,
  //   ],
  // },
  // {
  //   title: "policiesv7",
  //   link: "policy",
  //   type: "collapse",
  //   icon: "policies",
  //   roles: [
  //     Roles.GroupAdmin,
  //     Roles.CompanyAdmin,
  //     Roles.SiteAdmin,
  //     Roles.AGMSAdmin, Roles.PartnerAdmin,
  //   ],
  //   children: [
  //     {
  //       title: "policyHome",
  //       link: "home",
  //       roles: [
  //         Roles.CompanyAdmin,
  //         Roles.GroupAdmin,
  //         Roles.SiteAdmin,
  //         Roles.AGMSAdmin, Roles.PartnerAdmin,
  //       ],
  //     },
  //     {
  //       title: "spmGlobal",
  //       link: "spm-global",
  //       roles: [
  //         Roles.CompanyAdmin,
  //         Roles.GroupAdmin,
  //         Roles.SiteAdmin,
  //         Roles.AGMSAdmin, Roles.PartnerAdmin,
  //       ],
  //     },
  //     {
  //       title: "spmLocal",
  //       link: "spm-local",
  //       roles: [
  //         Roles.CompanyAdmin,
  //         Roles.GroupAdmin,
  //         Roles.SiteAdmin,
  //         Roles.AGMSAdmin, Roles.PartnerAdmin,
  //       ],
  //     }
  //   ]
  // },
  {
    title: "settings",
    link: "settings",
    name: "/settings",
    type: "collapse",
    icon: "settings",
    roles: [
      Roles.AGMSAdmin,
      Roles.PartnerAdmin,
      Roles.CompanyAdmin,
      Roles.SiteAdmin,
      Roles.GroupAdmin,
    ],
    children: [
      {
        title: "ssoSettings",
        link: "sso-settings",
        roles: [Roles.AGMSAdmin,Roles.PartnerAdmin,Roles.CompanyAdmin],
      },
      {
        title: "hashLookup",
        link: "hash-lookup",
        roles: [Roles.AGMSAdmin],
      },
      {
        title: "smtpSettings",
        link: "smtp-settings",
        roles: [Roles.AGMSAdmin],
      },
      {
        title: "syslogSettings",
        link: "syslog-settings",
        roles: [Roles.CompanyAdmin],
      },
      {
        title: "agentSettings",
        link: "agent-settings",
        roles: [Roles.CompanyAdmin],
      },
      {
        title: "adminModeSettings",
        link: "admin-mode-settings",
        roles: [Roles.CompanyAdmin],
      },
      {
        title: "installationSettings",
        link: "installation-settings",
        roles: [Roles.CompanyAdmin],
      },
      {
        title: "pdpLrpConfiguration",
        link: "pdp-lrp-list",
        roles: [
          Roles.AGMSAdmin,
          Roles.PartnerAdmin,
          Roles.CompanyAdmin,
          Roles.SiteAdmin,
          Roles.GroupAdmin
        ],
      },
    ],
  },
];

export default sidebarItems;
